import React, { useEffect, useState, useCallback } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@mui/material';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Card,
  CardContent,
  Grid,
  Container,
  useTheme,
  useMediaQuery,
  Collapse,
  Snackbar,
  Alert
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Popover,
  TextField,
  MenuItem,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getAllLeadsAction, getDeletedLeadAction, searchLeadAction } from '../../redux/actions/leadActions';
import { formatPhoneNumber } from '../../common/helpers/commonFun';
import CsvImportButton from '../../common/helpers/CSVImportButton';
import NoDataFound from '../../common/NoDataFound';
import { margin } from 'polished';

const agents = ['John Doe', 'Jane Smith'];
const sources = ['Website', 'Referral', 'Instagram'];
const locations = ['Miami West', 'Texas West'];
const statuses = ['New', 'Contacted', 'Dead'];


const searchCriteria = [
  { value: 'name', label: 'Name' },
  { value: 'phoneNumber', label: 'Phone Number' },
  { value: 'email', label: 'Email' },
  { value: 'type', label: 'Type' },
  { value: 'leadSource', label: 'Lead Source' },
  { value: 'quoteNumber', label: 'Quote Number' },
  { value: 'businessType', label: 'Business Type' },
  { value: 'assignedTo', label: 'Assigned To' },
  { value: 'status', label: 'Status' }
];

const GetAllLeads = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [leadToDelete, setLeadToDelete] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchExpanded, setSearchExpanded] = useState(false);
const [searchTrigger, setSearchTrigger] = useState(0);
  
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const { allFiles = [], getallFiles = [] } = useSelector(
  (state) => state.csvImport || {}
);

const GetAllCSVFiles = useSelector(
  (state) => state.csvImport?.getallFiles || []
);


const displayData = Array.isArray(getallFiles) && getallFiles.length > 0 
  ? getallFiles 
  : Array.isArray(allFiles) 
  ? allFiles 
  : [];


  const [filters, setFilters] = useState({
    zip: '',
    agent: '',
    source: '',
    location: '',
    status: '',
    fromDate: dayjs('2024-12-31'),
    toDate: dayjs('2025-12-31')
  });

  
  const [searchState, setSearchState] = useState({
    searchBy: 'name',
    searchValue: '',
    isSearchActive: false
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (field) => (e) => {
    setFilters({ ...filters, [field]: e.target.value });
  };

  const handleSearchChange = (field) => (event) => {
    if (field === 'searchBy') {
      setSearchState({
        searchBy: event.target.value,
        searchValue: '',
        isSearchActive: false
      });
    } else {
      setSearchState({
        ...searchState,
        [field]: event.target.value
      });
    }
  };

  const open = Boolean(anchorEl);

  const handleReset = () => {
    setFilters({
      zip: '',
      agent: '',
      source: '',
      location: '',
      status: '',
      fromDate: dayjs('2024-12-31'),
      toDate: dayjs('2025-12-31')
    });
  };

 
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
  if (location.state?.noteUpdated) {
    showSnackbar('Note updated successfully!');
    window.history.replaceState({}, document.title); // clears state after showing
  }
}, [location.state]);


  // Memoized function to fetch all leads
  const fetchAllLeads = useCallback(() => {
    dispatch(getAllLeadsAction(page, rowsPerPage));
  }, [dispatch, page, rowsPerPage]);

  // Memoized function to search leads
  const fetchSearchResults = useCallback(() => {
    if (searchState.searchBy && searchState.searchValue) {
      const searchData = {
        [searchState.searchBy]: searchState.searchValue
      };
      dispatch(searchLeadAction(searchData, page, rowsPerPage));
    }
  }, [dispatch, searchState.searchBy, searchState.searchValue, page, rowsPerPage]);

  // const handleSearch = () => {
  //   if (searchState.searchBy && searchState.searchValue) {
  //     setSearchState({ ...searchState, isSearchActive: true });
  //     setPage(0); // Reset to first page when searching
  //   }
  // };
  const handleSearch = () => {
  if (!searchState.searchBy || !searchState.searchValue.trim()) {
    showSnackbar('Please select a search criteria and enter a search value', 'warning');
    return;
  }

  setSearchState({ ...searchState, isSearchActive: true });
   setSearchTrigger(prev => prev + 1);
  setPage(0); // Reset to first page when searching
};
  const handleSearchReset = () => {
  setSearchState({
    searchBy: 'name',
    searchValue: '',
    isSearchActive: false
  });
  setPage(0); // Reset to first page when clearing search
setSearchTrigger(0);
  // Show confirmation message
  showSnackbar('Search filters have been reset', 'info');
};

  // Single useEffect to handle data fetching
  // useEffect(() => {
  //   if (searchState.isSearchActive) {
  //     fetchSearchResults();
  //   } else {
  //     fetchAllLeads();
  //   }
  // }, [searchState.isSearchActive, fetchAllLeads]);
  useEffect(() => {
  if (searchState.isSearchActive) {
    let searchData = {
      [searchState.searchBy]: searchState.searchValue
    };

    if (searchState.searchBy === "assignedTo") {
      searchData = { assignedTo: searchState.searchValue };
    }
    dispatch(searchLeadAction(searchData, page, rowsPerPage));
  } else {
    dispatch(getAllLeadsAction(page, rowsPerPage));
  }
}, [
  searchState.isSearchActive,
  searchTrigger, 
  page,
  rowsPerPage,
  dispatch
]);

  const get_all_leads = useSelector((state) => {
    if (searchState.isSearchActive) {
      return state.leads?.searchLeads?.content || [];
    }
    return state.leads?.allLeads?.content || [];
  });

  const totalLeads = useSelector((state) => {
    if (searchState.isSearchActive) {
      return state.leads?.searchLeads?.totalElements || 0;
    }
    return state.leads?.allLeads?.totalElements || 0;
  });

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Mobile Lead Card Component
  const LeadCard = ({ lead, index }) => (
    <Card
      key={index}
      variant="outlined"
      sx={{
        mb: 2,
        '&:hover': {
          boxShadow: 3,
          borderColor: 'primary.main'
        }
      }}
    >
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Grid container spacing={2}>
          {/* Header Row */}
          <Grid item xs={12}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              gap: 1
            }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: '1rem', sm: '1.125rem' },
                  color: 'primary.main'
                }}
              >
                {lead.firstName} {lead.lastName}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  size="small"
                  onClick={() => navigate('/createlead', { state: { leadData: lead } })}
                  sx={{
                    color: 'black',
                    '&:hover': { bgcolor: 'grey.200' }
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    setLeadToDelete(lead.id);
                    setDeleteDialogOpen(true);
                  }}
                  sx={{
                    color: 'black',
                    '&:hover': { bgcolor: 'grey.200' }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Phone
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {lead.phoneNumber || '-'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Email
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  wordBreak: 'break-word'
                }}
              >
                {lead.email || '-'}
              </Typography>
            </Box>
          </Grid>

          {/* Status and Quote */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Status
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {lead.status || 'Unknown'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Quote Number
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {lead.quoteNumber || '-'}
              </Typography>
            </Box>
          </Grid>

          {/* Dates */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Created Date
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {lead.createdBy?.timestamp ? dayjs(lead.createdBy.timestamp).format("MM-DD-YYYY") : "-"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Updated Date
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {lead.updatedBy?.timestamp ? dayjs(lead.updatedBy.timestamp).format("MM-DD-YYYY") : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  // Handle delete lead with proper state management
  const handleDeleteLead = async () => {
    if (leadToDelete) {
      try {
        await dispatch(getDeletedLeadAction(leadToDelete));

        // Show success snackbar
        showSnackbar('Lead deleted successfully!');

        // After successful deletion, refresh the current view
        if (searchState.isSearchActive) {
          fetchSearchResults();
        } else {
          fetchAllLeads();
        }

        setDeleteDialogOpen(false);
        setLeadToDelete(null);
      } catch (error) {
        showSnackbar('Error deleting lead!', 'error');
      }
    }
  };

  const handleImportSuccess = () => {
  dispatch(getAllLeadsAction(page, rowsPerPage));
};

const createLeadHander = () => {
  navigate("/createlead");
}

  return (
    <Container
      maxWidth={false}
      sx={{
        px: { xs: 1, sm: 2, md: 3 },
        py: { xs: 2, sm: 3 }
      }}
    >
      {/* Header */}
      <Box sx={{ mb: { xs: 2, sm: 3 } }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
        >
          <Typography
            variant={isMobile ? "h5" : "h4"}
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.25rem', sm: '1.5rem' }
            }}
          >
            Leads ({totalLeads})
          </Typography>
        </Stack>
      </Box>

      {/* Search Section */}
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: isMobile ? 2 : 0
          }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Search Leads
            </Typography>
            {isMobile && (
              <IconButton
                onClick={() => setSearchExpanded(!searchExpanded)}
                size="small"
              >
                {searchExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </Box>

          <Collapse in={!isMobile || searchExpanded}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              justifyContent={{ xs: 'space-between', sm: 'space-between'}}
              sx={{ mt: 2 }}
            >
            <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                <TextField
                select
                label="Search By"
                value={searchState.searchBy}
                onChange={handleSearchChange('searchBy')}
                size={isMobile ? "small" : "medium"}
                sx={{
                  minWidth: { xs: '100%', sm: 200 }
                }}
              >
                {searchCriteria.map((criteria) => (
                  <MenuItem key={criteria.value} value={criteria.value}>
                    {criteria.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                label="Search Value"
                value={searchState.searchValue}
                onChange={handleSearchChange('searchValue')}
                placeholder="Enter search value"
                size={isMobile ? "small" : "medium"}
                sx={{
                  minWidth: { xs: '100%', sm: 250 },
                  margin:'0 15px'
                }}
                disabled={!searchState.searchBy}
              />

              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={handleSearch}
                disabled={!searchState.searchBy || !searchState.searchValue.trim()}
                
              >
                Search
              </Button>

              <Button
                variant="outlined"
                sx={{margin: '0 20px'}}
                onClick={handleSearchReset}
               
              >
                Reset
              </Button>
            </Box>

  {/* Right section: Import CSV */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",     
    }}   
  >
    <Button variant='outlined' sx={{margin: '0 20px'}} onClick={createLeadHander}>Create New Lead</Button>
    <CsvImportButton onImportSuccess={handleImportSuccess} />
  </Box>


            </Stack>

            {searchState.isSearchActive && (
              <Typography
                variant="body2"
                color="primary"
                sx={{
                  mt: 2,
                  p: 1,
                  bgcolor: 'primary.50',
                  borderRadius: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                Showing search results for "{searchState.searchBy}: {searchState.searchValue}"
              </Typography>
            )}
          </Collapse>
        </CardContent>
      </Card>

      {/* Data Display */}
     {isMobile ? (
  // Mobile Card Layout
  <Box>
    {get_all_leads.length > 0 ? (
      get_all_leads.map((lead, idx) => (
        <LeadCard key={lead.id || idx} lead={lead} index={idx} />
      ))
    ) : (
      <NoDataFound />
    )}
  </Box>
) : (
  // ✅ Desktop Table Layout
  <Card>
    
     <TableContainer
                component={Paper}
                sx={{
                  maxHeight: isMobile ? '60vh' : 'none',
                  overflow: 'auto',
                  boxShadow: isMobile ? 1 : 2
                }}
              >
                <Table
                  stickyHeader
                  sx={{
                    minWidth: isMobile ? '800px' : '650px',
                    '& .MuiTableCell-root': {
                      fontSize: isMobile ? '11px' : '14px',
                      padding: isMobile ? '6px 8px' : '12px 16px',
                      whiteSpace: isMobile ? 'nowrap' : 'normal',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: isMobile ? '120px' : '200px'
                    }
                  }}
                  size={isMobile ? "small" : "medium"}
                >
          <TableHead>
            <TableRow>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Lead Name</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Phone</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Email Address</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Status</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Quote Number</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Created Date</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Updated Date</TableCell>
              <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
   {get_all_leads.map((lead, idx) => (
                  <TableRow key={lead.id || idx} className="styled-table-row">
                    <TableCell>{lead.firstName} {lead.lastName}</TableCell>
                    <TableCell>{formatPhoneNumber(lead.phoneNumber)}</TableCell>
                    <TableCell>{lead.email}</TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {lead.status || 'Unknown'}
                      </Typography>
                    </TableCell>
                    <TableCell>{lead.quoteNumber}</TableCell>
                    <TableCell>
                      {lead.createdBy?.timestamp ? dayjs(lead.createdBy.timestamp).format("MM-DD-YYYY") : "-"}
                    </TableCell>
                    <TableCell>
                      {lead.updatedBy?.timestamp ? dayjs(lead.updatedBy.timestamp).format("MM-DD-YYYY") : "-"}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton
                          onClick={() => navigate('/createlead', { state: { leadData: lead } })}
                          size="small"
                          sx={{
                            color: 'black',
                            '&:hover': { bgcolor: 'grey.200' }
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            setLeadToDelete(lead.id);
                            setDeleteDialogOpen(true);
                          }}
                          size="small"
                          sx={{
                            color: 'black',
                            '&:hover': { bgcolor: 'grey.200' }
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}

</TableBody>
        </Table>
      </TableContainer>
  </Card>
)}


      {/* Pagination */}
      {totalLeads > 0 && (
        <Box sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" },
          alignItems: "center",
          padding: { xs: "1rem 0", sm: "1rem" },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 1 }
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            fontSize: { xs: "12px", sm: "14px" }
          }}>
            <span style={{ marginRight: 8 }}>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              style={{
                padding: "6px 12px",
                borderRadius: "4px",
                borderColor: "#ccc",
                fontSize: isMobile ? "12px" : "14px"
              }}
            >
              {[5, 10, 15, 25].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </Box>

          <Pagination
            count={Math.ceil(totalLeads / rowsPerPage)}
            page={page + 1}
            onChange={(event, value) => handlePageChange(event, value - 1)}
            showFirstButton
            showLastButton
            size={isMobile ? "small" : "medium"}
            sx={{ ml: { xs: 0, sm: 2 } }}
          />
        </Box>
      )}

      {/* Filter Popover */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          sx: {
            padding: 2,
            width: { xs: '95vw', sm: 700 },
            maxWidth: '95vw'
          }
        }}
      >
        <Box component="form" noValidate autoComplete="off">
          <Stack spacing={2} direction="column">
            {/* First Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" sx={{ mb: 1 }}>Enter the zip code</Typography>
                <TextField
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                  value={filters.zip}
                  onChange={handleChange('zip')}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" sx={{ mb: 1 }}>Select Agent</Typography>
                <TextField
                  select
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                  value={filters.agent}
                  onChange={handleChange('agent')}
                >
                  {agents.map((a) => (
                    <MenuItem key={a} value={a}>{a}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" sx={{ mb: 1 }}>Lead Source</Typography>
                <TextField
                  select
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                  value={filters.source}
                  onChange={handleChange('source')}
                >
                  {sources.map((s) => (
                    <MenuItem key={s} value={s}>{s}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>

            {/* Date Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Typography variant="body2" sx={{ mb: 1 }}>From</Typography>
                  <DatePicker
                    value={filters.fromDate}
                    onChange={(date) => setFilters({ ...filters, fromDate: date })}
                    slotProps={{
                      textField: {
                        size: isMobile ? "small" : "medium",
                        fullWidth: true
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Typography variant="body2" sx={{ mb: 1 }}>To</Typography>
                  <DatePicker
                    value={filters.toDate}
                    onChange={(date) => setFilters({ ...filters, toDate: date })}
                    slotProps={{
                      textField: {
                        size: isMobile ? "small" : "medium",
                        fullWidth: true
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" sx={{ mb: 1 }}>Lead Status</Typography>
                <TextField
                  select
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                  value={filters.status}
                  onChange={handleChange('status')}
                >
                  {statuses.map((s) => (
                    <MenuItem key={s} value={s}>{s}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>

            {/* Location Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" sx={{ mb: 1 }}>Select Location</Typography>
                <TextField
                  select
                  fullWidth
                  size={isMobile ? "small" : "medium"}
                  value={filters.location}
                  onChange={handleChange('location')}
                >
                  {locations.map((l) => (
                    <MenuItem key={l} value={l}>{l}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </Stack>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="flex-end"
            spacing={2}
            sx={{ mt: 3 }}
          >
            <Button
              variant="outlined"
              className='btn-secondary'
              onClick={handleReset}
              fullWidth={isMobile}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              className='btn-primary'
              onClick={handleClose}
              fullWidth={isMobile}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Popover>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } setDeleteDialogOpen(false); }}
        aria-labelledby="confirm-delete-dialog-title"
        aria-describedby="confirm-delete-dialog-description"
        maxWidth="sm"
        fullWidth
        disableScrollLock={true}
        keepMounted={false}
        hideBackdrop={false}
        style={{ zIndex: 1300 }}
        PaperProps={{
          sx: {
            m: { xs: 2, sm: 3 },
            width: { xs: 'calc(100% - 32px)', sm: 'auto' }
          }
        }}
      >
          <DialogTitle
                    className="btn-primary"
                    sx={{
                      height: isMobile ? '56px' : '64px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: isMobile ? '0 12px' : '0 16px',
                      fontSize: isMobile ? '16px' : '18px'
                    }}
                    id="confirm-delete-dialog-title"
                  >
                    Confirm Deletion
                  </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Are you sure you want to delete this lead? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 1, sm: 0 },
          p: { xs: 2, sm: 1 }
        }}>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            variant='outlined'
            fullWidth={isMobile}
          >
            Cancel
          </Button>
          <Button           
            variant='outlined'
            fullWidth={isMobile}
                color="error"
            onClick={handleDeleteLead}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default GetAllLeads;